export const GET_INSTAGRAM_POSTS_RECEIVE = "GET_INSTAGRAM_POSTS_RECEIVE";
export const GET_INSTAGRAM_POSTS_FAILURE = "GET_INSTAGRAM_POSTS_FAILURE";
export const GET_INSTAGRAM_POSTS_REQUEST = "GET_INSTAGRAM_POSTS_REQUEST";

const Vendor = {
  GET_INSTAGRAM_POSTS_RECEIVE,
  GET_INSTAGRAM_POSTS_FAILURE,
  GET_INSTAGRAM_POSTS_REQUEST,
};

export default Vendor;
